import React from 'react';
import FirstaidDemo from 'views/FirstaidDemo';

const LifeSkillPage = () => {
  return <FirstaidDemo/>;
};

export default LifeSkillPage;
